// Do NOT import anything into this file; doing so will
// cause issues when this file is imported into the server runtime
export type PCIRouteName =
  | 'CHECKOUT'
  | 'SECURE_ADD_GIFT_CARD_PAYMENT'
  | 'SECURE_ADD_PAYMENT'
  | 'SECURE_ADD_MEMBERSHIP_PAYMENT'
  | 'SECURE_CHOOSE_MEMBERSHIP_PAYMENT'

export type PCIRoute = {
  url: string
  trackingName: string
  storeRequired?: boolean
  selfGuardsAccess: boolean
  access: (typeof AccessLevel)[keyof typeof AccessLevel]
}

// duplicated from shared/constants/accessLevel.ts ON PURPOSE
// to avoid importing anything into this file.
const AccessLevel = {
  Public: 0,
  UserOrGuest: 1,
  UserOnly: 2,
} as const

type PCIRouteDictionary = {
  [P in PCIRouteName]: PCIRoute
}

export const pciRouteDictionary = {
  CHECKOUT: {
    access: AccessLevel.UserOnly,
    url: '/shop/checkout',
    trackingName: 'checkout',
    storeRequired: true,
    selfGuardsAccess: false,
  },
  SECURE_ADD_GIFT_CARD_PAYMENT: {
    access: AccessLevel.Public,
    url: '/secure/add-gift-card-payment',
    trackingName: 'gift_add_payment',
    selfGuardsAccess: false,
  },
  SECURE_ADD_PAYMENT: {
    access: AccessLevel.UserOrGuest,
    url: '/secure/add-payment',
    trackingName: 'wallet_add_payment',
    selfGuardsAccess: false,
  },
  SECURE_ADD_MEMBERSHIP_PAYMENT: {
    access: AccessLevel.UserOrGuest,
    url: '/secure/add-membership-payment',
    trackingName: 'membership_add_payment',
    selfGuardsAccess: false,
  },
  SECURE_CHOOSE_MEMBERSHIP_PAYMENT: {
    access: AccessLevel.UserOrGuest,
    url: '/secure/choose-membership-payment',
    trackingName: 'choose_membership_add_payment',
    selfGuardsAccess: false,
  },
} as const satisfies PCIRouteDictionary

export const pciRouteMapByURL = new Map<string, PCIRoute>(
  Object.values(pciRouteDictionary).map((route) => [route.url, route]),
)
